import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Trash2, Scissors } from 'lucide-react';
import { CropArea, CropAreaData } from './CropArea';

interface CropManagerProps {
  crops: CropAreaData[];
  onDeleteCrop: (id: string) => void;
  onClearAll: () => void;
  onStartCropping: () => void;
  isProcessing?: boolean;
}

export const CropManager = ({ 
  crops, 
  onDeleteCrop, 
  onClearAll, 
  onStartCropping,
  isProcessing = false
}: CropManagerProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium">Cropped Regions</h3>
          <Badge variant="secondary" className="text-xs">
            {crops.length}
          </Badge>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onStartCropping}
            disabled={isProcessing}
          >
            <Scissors className="w-4 h-4 mr-2" />
            Add Crop
          </Button>
          
          {crops.length > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearAll}
              disabled={isProcessing}
              className="text-destructive hover:text-destructive"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Clear All
            </Button>
          )}
        </div>
      </div>

      {crops.length > 0 && (
        <div className="grid grid-cols-3 gap-2 max-h-32 overflow-y-auto">
          {crops.map((crop) => (
            <CropArea
              key={crop.id}
              crop={crop}
              onDelete={onDeleteCrop}
            />
          ))}
        </div>
      )}

      {crops.length === 0 && (
        <div className="text-center py-4 text-muted-foreground text-sm">
          No crops selected. Click "Add Crop" to select regions for processing.
        </div>
      )}
    </div>
  );
};